import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CardImage from '../card-image/card-image';
import { getPlasticType } from '../../actions/maintenanceActions';

/**
 * Card Image Lookup Component - loads image by passing in plasticTypeId
 * @param isLarge Flag to determine whether card image should be displayed as the large or small variant
 * @param isDigital If true then show E icon in top right corner
 * @param plasticTypeId Id to retrieve plastic type from back end
 * @returns JSX Element
 */

const CardImageLookup = ( { isLarge, isDigital, plasticTypeId }) => {
  const dispatch = useDispatch();
  const plasticType = useSelector((state) => state.maintenanceStore.plasticType);

  useEffect(() => {
    if (plasticTypeId) {
      dispatch(getPlasticType(plasticTypeId));
    }
  }, [plasticTypeId]);

  return <>
    <CardImage
      isLarge={isLarge}
      isDigital={isDigital}
      imageSource={plasticType?.image?.url}
    />
  </>;
};

export default CardImageLookup;
